import React from "react";
import "./style.scss";

const NoRecordsFound = (props) => {
  return (
    <div className="no-records-container">
      <div>
        <i className="pi pi-inbox" />
      </div>
      <p>{props.message || "No Records Found"}</p>
    </div>
  );
};

export default NoRecordsFound;
